import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-next-phase',
  templateUrl: './next-phase.component.html',
  styleUrls: ['./next-phase.component.scss']
})
export class NextPhaseComponent implements OnInit {
  @Output() isNextPhaseModalVisible = new EventEmitter<boolean>();
  showPhaseButton: boolean = false;
  constructor() {}

  ngOnInit(): void {
  }

  moveToNextPhase() {
    this.isNextPhaseModalVisible.emit(true);
  }
}
